import { login, logout, getInfo,menuList } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import MenuUtils from '@/utils/menu'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

const getDefaultState = () => {
  return {
    token: getToken(),
    routesList: [],
    name: '',
    avatar: '',
    serviceCodes: '',
    userId: JSON.parse(localStorage.getItem('userId'))
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_ROUTES: (state, routes) => {
    state.routesList = routes
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_SERVICECODE: (state, serviceCodes) => {
    state.serviceCodes = serviceCodes
    localStorage.setItem('serviceCodes', serviceCodes)
  },
  SET_USERID: (state, userId) => {
    state.userId = userId
    localStorage.setItem('userId', JSON.stringify(userId))
  },
  SET_DEPTID: (state, deptId) => {
    state.deptId = deptId
    localStorage.setItem('deptId', deptId)
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { loginName, loginPassword, timeStamp, token } = userInfo
    return new Promise((resolve, reject) => {
      login({ loginName: loginName.trim(), loginPassword: loginPassword, token1: timeStamp, token2: token }).then(response => {
        const { data } = response
        if (response.code !== 0){
          if (response.message != null && '' != response.message){
            reject(response.message)
          }
        }
        commit('SET_TOKEN', data.token)
        commit('SET_USERID', data.id)
        commit('SET_SERVICECODE', data.serviceCodes)
        commit('SET_NAME', data.userName)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const userInfo = response.data.user

        if (!userInfo) {
          return reject('Verification failed, please Login again.')
        }

        commit('SET_USERID', userInfo.userName)
        commit('SET_NAME', userInfo.userName)
        // commit('SET_AVATAR', avatar)
        resolve(userInfo)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
		removeToken() // must remove  token  first
		commit('RESET_STATE')
    localStorage.removeItem('userId')
		resolve()
      /* logout(state.token).then(() => {
        removeToken() // must remove  token  first
        commit('RESET_STATE')
        resolve()
      }).catch(error => {
        reject(error)
      }) */
    })
  },
  // 获取菜单
  generateRoutes({ commit }) {

    return new Promise((resolve, reject) => {
      menuList()
        .then(res => {
          const accessedRoutes = []
          if (res.rows.length > 0) {
            MenuUtils(accessedRoutes, res.rows)
            commit('SET_ROUTES', accessedRoutes)
            resolve(accessedRoutes)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/user.js